export default {
    setCalculator: (state, calc) => { state.calculator = calc },
    setCalculatorParameters: (state, calculatorParameters) => { state.calculatorParameters = calculatorParameters },
    setWeight: (state, weight) => { state.weight = weight },
    setVolume: (state, volume) => { state.volume = volume },
    setFluidRateUnit: (state, fluidRateUnit) => { state.fluidRateUnit = fluidRateUnit },
    setFluidRate: (state, fluidRate) => { state.fluidRate = fluidRate },
    setCurrentHematocrit: (state, currentHematocrit) => { state.currentHematocrit = currentHematocrit },
    setDonorHematocrit: (state, donorHematocrit) => { state.donorHematocrit = donorHematocrit },
    setIntendedHematocrit: (state, intendedHematocrit) => { state.intendedHematocrit = intendedHematocrit },
    setAnimal: (state, animal) => { state.animal = animal },
    setDrugs: (state, drugs) => { state.drugs = drugs || [] },
    setDrugsConcentrations: (state, drugsConcentrations) => { state.drugsConcentrations = drugsConcentrations },
}